import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Ray silhouette uses the ★1 tier art. The active rendering for
// Sky Ray goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/sky_ray_3tier.jpg.
export const Ray = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/ray-1.png" size={size} alt="ray" />
)
